import React from 'react';
import { useParams } from 'react-router-dom';
import { useAdminAccountQuery } from '../../../../queries';
import { MultiContainerHeader } from '../../../../web/components/MultiContainerHeader';
import { MastheadPortalId } from '../../../../models/AdminModels';
import { BreadcrumbsBarWithNameProvider } from '../../../components/blogs/BreadcrumbsBarWithNameProvider';
import { BlogImportHistory as BlogImportHistoryComponent } from '../../../components/blogs/BlogImportHistory';

export const BlogImportHistory: React.FC = () => {
	const { id: accountId } = useParams<{ id: string }>();

	const { data: account } = useAdminAccountQuery({
		accountId,
		meta: {
			toastErrorMessage: 'Error fetching account',
			errorLogging: {
				category: 'BlogImportHistory',
				action: 'GetAdminAccountQuery-Error',
			},
		},
	});

	if (!accountId) {
		return <div>Account ID is required</div>;
	}

	return (
		<div className='admin-blog-import-history-container'>
			<MultiContainerHeader
				appBarHeader={<BreadcrumbsBarWithNameProvider account={account} currentLocation='Blog Import History' />}
				appBarPortalDestinationId={MastheadPortalId}
			/>
			{account && <BlogImportHistoryComponent accountId={accountId} />}
		</div>
	);
};
